const React = require('react');

const { OKCheckbox } = require('commonsComponents/OKCheckbox');

const listItem = (label, checked) => {
    return (
        <div className="row mortgage-request-view-process__panel-left-list-item">
            <span className="pull-left">
                {label}
            </span>
            <span className="pull-right mortgage-request-view-process__panel-left-list-item-checkbox">
                <OKCheckbox idName={label} disabled={true} value={checked} />
            </span>
        </div>
    );
};

module.exports = listItem;
